<template>
  <div class>
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>
        <v-icon class="icon">fa-plus</v-icon>Add Account Manager
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small @click="closePanel" :color="this.$gf.headerColor()">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-form>
            <v-text-field
              :error-messages="messages.first_name"
              v-model="user.first_name"
              label="First Name"
              type="text"
            ></v-text-field>
            <v-text-field
              :error-messages="messages.last_name"
              v-model="user.last_name"
              label="Last Name"
              type="text"
            ></v-text-field>
            <v-text-field
              :error-messages="messages.email"
              v-model="user.email"
              label="Email"
              type="text"
            ></v-text-field>
            <v-select
              v-model="user.permission"
              :items="managerPermission"
              item-text="name"
              item-value="id"
              label="Allow Account manager to Create Customer(s)"
              class="mt-4"
              :menu-props="{ maxHeight: '400' }"
              attach
            ></v-select>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn color="primary" class="mr-1" @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" @click="addUser">Add Account Manager</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import userAPI from "@/api/user.js";

export default {
  name: "AddOwner",
  props: {
    params: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      searchParams: "",
      user: {},
      messages: {},
      successMessage: "Account Manager Successfully Added.",
      errorMessage:
        "Oops, something went wrong! Please check information is correct.",
      managerPermission: [
        {
          id: 1,
          name: "Yes"
        },
        {
          id: 0,
          name: "No"
        }
      ],
      loading: false,
    };
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
    },
    addUser() {
      this.loading = true;
      userAPI
        .createManager(this.user,this.id)
        .then(() => {
          this.closePanel();
          EventBus.$emit("USERS_UPDATED", this.params);
          this.$snotify.success(this.successMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
            this.loading = false;
        })
        .catch(err => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
            this.loading = false;
        });
    }
  }
};
</script>
